import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn/cn';
import { Input, type CustomProps } from './Input';

export interface InputCurrencyProps extends CustomProps {
  currency?: 'EUR' | 'CHF';
  currencyPosition?: 'left' | 'right';
  customInputRef?: HTMLInputElement;
}
const getCurrencySymbol = (currency: 'EUR' | 'CHF'): string => {
  const symbols: Record<'EUR' | 'CHF', string> = {
    EUR: '€',
    CHF: 'CHF',
  };
  return symbols[currency];
};
export const InputCurrency = forwardRef<HTMLInputElement, InputCurrencyProps>(
  (
    {
      currency = 'EUR',
      currencyPosition = 'right',
      containerClassName,
      customInputRef,
      helperText,
      label,
      className,
      disabled,
      ...props
    },
    ref,
  ) => {
    const currencySymbol = getCurrencySymbol(currency);
    const style = {
      '--customPadding': currencySymbol.length === 1 ? '2rem' : '3.5rem',
    } as React.CSSProperties;
    return (
      <Input
        ref={ref}
        {...props}
        className={cn(
          currencyPosition === 'right' ? 'pr-[var(--customPadding)]' : 'pl-[var(--customPadding)]',
          className,
        )}
        style={style}
        label={label}
        helperText={helperText}
        containerClassName={cn(containerClassName)}
        disabled={disabled}
      >
        <span
          className={cn(
            `pointer-events-none absolute ${currencyPosition === 'right' ? 'right-2' : 'left-2'} top-[25%] ${disabled ? 'opacity-35' : ''}`,
          )}
        >
          {currencySymbol}
        </span>
      </Input>
    );
  },
);
